module.exports = "/_next/static/images/880e289420544c0c6f05204823814954-currency-icon.svg";